import athleteApi from './api'

export interface UpdateProfileRequest {
  name?: string
  email?: string
  searchable?: boolean
}

export interface UpdateSportsRequest {
  sports: number[]
}

export interface UpdatePreferencesRequest {
  field: string
  values: string[]
}

export interface UpdateSchoolRequest {
  school_id: number | null
}

export interface AvatarUploadUrlRequest {
  mimeType: string
}

export interface AvatarUploadUrlResponse {
  presignedUrl: string
  publicUrl: string
  upload: {
    id: string
    url: string
    upload_type: string
  }
}

export interface UpdateAvatarRequest {
  avatarUrl: string
}

/**
 * Update athlete profile information and marketplace visibility
 */
export const updateProfile = async (profileData: UpdateProfileRequest) => {
  try {
    const { data } = await athleteApi.patch('/athlete/profile', profileData)
    return data
  } catch (error: any) {
    throw new Error(`Failed to update profile: ${error.response?.data?.error || error.message}`)
  }
}

/**
 * Update athlete sports
 */
export const updateSports = async (sportsData: UpdateSportsRequest) => {
  try {
    const { data } = await athleteApi.patch('/athlete/sports', sportsData)
    return data
  } catch (error: any) {
    throw new Error(`Failed to update sports: ${error.response?.data?.error || error.message}`)
  }
}

/**
 * Update athlete school
 */
export const updateSchool = async (schoolData: UpdateSchoolRequest) => {
  try {
    const { data } = await athleteApi.patch('/athlete/school', schoolData)
    return data
  } catch (error: any) {
    throw new Error(`Failed to update school: ${error.response?.data?.error || error.message}`)
  }
}

/**
 * Update athlete preferences
 */
export const updatePreferences = async (preferencesData: UpdatePreferencesRequest) => {
  try {
    const { data } = await athleteApi.patch('/athlete/preferences', preferencesData)
    return data
  } catch (error: any) {
    throw new Error(
      `Failed to update preferences: ${error.response?.data?.error || error.message}`,
    )
  }
}

// Deprecated uploadCroppedAvatar (used broken /me/avatar route) removed

/**
 * Manually update user avatar with a URL (optional fallback)
 * Only needed if you want to set avatar URL directly without uploading an image
 */
export const updateAvatarUrl = async (avatarUrl: string) => {
  try {
    const { data } = await athleteApi.patch('/users/me/avatar', { avatarUrl })
    return data
  } catch (error: any) {
    throw new Error(`Failed to update avatar: ${error.response?.data?.error || error.message}`)
  }
}
